import { ApiMenu, Menu } from "./types";

export const parseAPIMenu = (apiMenu: ApiMenu[]): Menu[] => {
    if (apiMenu!=null)
    {
        return apiMenu.map(apiMenuItem => {
        return {
            displayName: apiMenuItem.displayName,
            internalName: apiMenuItem.internalName,
            url: apiMenuItem.url,
            visible: apiMenuItem.visible,
            children: parseAPIMenu(apiMenuItem.children),
            icon: apiMenuItem.icon,
            package: apiMenuItem.package,
            settingsPanel: apiMenuItem.settingsPanel,
            lockdisconnect: apiMenuItem.lockdisconnect,
            hideIndustry: apiMenuItem.hideIndustry
        }
        })
    }
    else 
        return []
}
